import React from 'react';
import useAxios from '../../../hooks/useAxios';
import style from '../../../assets/style/common/interested.module.scss'
import { Link } from 'react-router-dom';
import InterestedCard from './InterestedCard'

function InterestedSection({type, data}) {
  let url = `interest/${type}`;
  const [Data] = useAxios(url);
  const interestData = Data.data;

  return (
    <>
    <div className={style.interestedMainDiv}>
    <div className={`container ${style.interestedContainer}`}>
      <h3 className={style.interestedH3}>You may also be interested in</h3>
      <div className='row'>
        {interestData?.map((item, index)=>
          <InterestedCard key={index} cardData = {item} type={type}  />
        )
        }
     
      </div>
    </div>
    </div>
    </>
  )
}

export default InterestedSection